import styled, { css } from 'styled-components';

import { getJobStatusStyles } from '@/console/features/jobs/components/job-status-styled-icon/job-status-style-icon.styled';
import { TPipelineStepStatusIconButtonProps } from '@/console/features/pipelines/components/pipeline-step-status-chip/pipeline-step-status-chip.types';
import { getBorderStyle } from '@/shared/components/ui/button/common/button-common.styled';
import { IconBgButton } from '@/shared/components/ui/button/icon-bg-button/icon-bg-button';

export const PipelineStepStatusIconButton = styled(
  IconBgButton,
)<TPipelineStepStatusIconButtonProps>`
  && {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;

    ${({ theme }) => theme.typography.p7};

    svg {
      height: 1rem;
      width: 1rem;
    }

    ${({ theme, $status = 'grey' }) => css`
      ${getJobStatusStyles($status)};

      &:hover {
        ${getBorderStyle(theme.palette.status[$status].text)};
        background-color: ${theme.palette.status[$status].background};
      }

      &:disabled {
        opacity: 1;
        color: ${theme.palette.status[$status].text};
        background-color: ${theme.palette.status[$status].background};
        svg {
          color: ${theme.palette.status[$status].text};
        }
      }
    `}
  }
`;
